import { render, staticRenderFns } from "./WowzaList.vue?vue&type=template&id=0ec8db3e&scoped=true"
import script from "./WowzaList.vue?vue&type=script&lang=js"
export * from "./WowzaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8db3e",
  null
  
)

export default component.exports